import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable()
export class AdBlockDetectorService {
	public adBlocker: Observable<boolean>;
	private adBlockerSource: ReplaySubject<boolean>;

	constructor(private httpClient: HttpClient) {
		this.adBlockerSource = new ReplaySubject<boolean>(1);
		this.adBlocker = this.adBlockerSource.asObservable();
		this.detectAdBlocker();
	}

	detectAdBlocker() {
		const url = 'https://static.doubleclick.net/instream/ad_status.js';

		this.httpClient.get(url, { responseType: 'text' })
			.subscribe(
				(result: any) => {
					this.adBlockerSource.next(false);
				},
				(error: any) => {
					this.adBlockerSource.next(true);
				}
			);
	}
}
